import React from 'react';
import { TreeDeciduous, CheckCircle, ArrowRight, ShieldCheck } from 'lucide-react';

const Footer: React.FC = () => {
  const scrollToForm = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#0F1419] overflow-hidden pt-24 pb-12">
      {/* Structural visual background: Subtle grid */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#059669_1px,transparent_1px),linear-gradient(to_bottom,#059669_1px,transparent_1px)] bg-[size:100px_100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
        <div className="mb-20">
          <span className="text-[#FF6B35] font-black uppercase tracking-[0.4em] text-sm mb-6 block">Ready to Scale Your Business?</span>
          <h2 className="text-4xl md:text-8xl font-black mb-8 uppercase italic leading-[0.9] tracking-tighter text-white">
            Stop Burning Cash.<br />Start <span className="text-[#059669]">Winning.</span>
          </h2>
          
          <div className="max-w-2xl mx-auto text-left mb-16 space-y-4">
            <div className="flex items-start gap-4 bg-white/5 p-6 rounded-2xl border border-white/10 backdrop-blur-md hover:border-[#FF6B35]/30 transition-colors">
              <CheckCircle className="w-7 h-7 text-[#059669] flex-shrink-0 mt-1" />
              <div>
                <p className="font-black text-white text-xl uppercase tracking-tight italic">Stop losing leads while you're in the tree.</p>
                <p className="text-gray-400 text-sm font-bold">Automated text-back secures the lead while you're still in the bucket.</p>
              </div>
            </div>
            <div className="flex items-start gap-4 bg-white/5 p-6 rounded-2xl border border-white/10 backdrop-blur-md hover:border-[#FF6B35]/30 transition-colors">
              <CheckCircle className="w-7 h-7 text-[#059669] flex-shrink-0 mt-1" />
              <div>
                <p className="font-black text-white text-xl uppercase tracking-tight italic">Reclaim 10+ hours of your week.</p>
                <p className="text-gray-400 text-sm font-bold">Let customers book their own estimates on your predefined schedule.</p>
              </div>
            </div>
            <div className="flex items-start gap-4 bg-white/5 p-6 rounded-2xl border border-white/10 backdrop-blur-md hover:border-[#FF6B35]/30 transition-colors">
              <CheckCircle className="w-7 h-7 text-[#059669] flex-shrink-0 mt-1" />
              <div>
                <p className="font-black text-white text-xl uppercase tracking-tight italic">Build a reputation that commands premium pricing.</p>
                <p className="text-gray-400 text-sm font-bold">Automated review requests push your Google ranking to the Top 3 in your town.</p>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="flex flex-col items-center gap-4">
              <div className="relative inline-block group">
                <div className="absolute -inset-1 bg-[#FF6B35] rounded-2xl blur opacity-30 group-hover:opacity-60 transition duration-300"></div>
                <a 
                  href="https://api.leadconnectorhq.com/widget/booking/C2VL0S6llGMFg5aY5whk"
                  className="relative bg-[#FF6B35] hover:bg-white hover:text-[#0F1419] text-2xl md:text-4xl font-black px-16 py-10 rounded-2xl transition-all shadow-2xl shadow-orange-900/40 uppercase tracking-tighter flex items-center gap-6 mx-auto text-white cursor-pointer"
                >
                  START YOUR FREE TRIAL <ArrowRight className="w-10 h-10 group-hover:translate-x-2 transition-transform" />
                </a>
              </div>
              <p className="text-[#FF6B35] font-black uppercase text-sm tracking-widest animate-pulse">
                ONLY 7 SPOTS LEFT THIS MONTH
              </p>
            </div>
            <div className="flex flex-col items-center gap-3">
              <p className="text-[#F4E4C1] font-black uppercase tracking-[0.2em] text-xs">
                Join 200+ other tree professionals today
              </p>
              <div className="flex items-center gap-2 text-[#059669] text-xs font-black uppercase">
                <ShieldCheck className="w-4 h-4" /> NO CONTRACTS. NO BS.
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-2 group cursor-pointer" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <div className="w-8 h-8 bg-[#059669]/20 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
              <TreeDeciduous className="w-5 h-5 text-[#059669]" />
            </div>
            <span className="font-black text-lg text-white tracking-tighter uppercase">ARBOR ADVANTAGE</span>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-8 text-[10px] text-gray-500 font-black uppercase tracking-widest">
            <a href="https://arboradvantage.com" className="hover:text-[#FF6B35] transition-colors">Home</a>
            <a href="https://arboradvantage.com/blog" className="hover:text-[#FF6B35] transition-colors">Blog</a>
            <a href="https://arboradvantage.com/post/resources" className="hover:text-[#FF6B35] transition-colors">Resources</a>
            <a href="#" className="hover:text-[#FF6B35] transition-colors">Terms</a>
            <a href="#" className="hover:text-[#FF6B35] transition-colors">Privacy</a>
          </div>

          <p className="text-[10px] text-gray-600 font-black uppercase tracking-widest">
            &copy; 2026 | Built By A Tree Pro For Tree Pros
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;